import acessoSistema from '@/core/apiclient/AcessoSistemaApiClient'
import contaContabil from './ContaContabilApiClient'
import fornecedor from './FornecedorApiClient'
import orgao from './OrgaoApiClient'
import patrimonio from './PatrimonioApiClient'
import produto from './ProdutoApiClient'
import setor from './SetorApiClient'
import usuario from './UsuarioApiClient'
import amortizacao from './AmortizacaoApiClient'
import relatorio from './RelatorioApiClient'
import fusoHorario from './FusoHorarioApiClient'
import camposPersonalizados from './CamposPersonalizadosApiClient'
import movimentacao from './MovimentacaoApiClient'
import dashboard from './DashboardApiClient'
import fundoEspecial from './FundoEspecialApiClient'
import fonteFinanciamento from './FonteFinanciamentoApiClient'
import projeto from './ProjetoApiClient'
import reavaliacao from './ReavaliacaoApiClient'
import parametros from './ParametrosApiClient'
import documento from './DocumentoApiClient'
import relatoriosTce from './RelatoriosTceApiClient'
import ajuste from './AjusteApiClient'

export default {
    acessoSistema,
    contaContabil,
    fornecedor,
    orgao,
    patrimonio,
    produto,
    setor,
    usuario,
    amortizacao,
    relatorio,
    fusoHorario,
    camposPersonalizados,
    movimentacao,
    dashboard,
    fundoEspecial,
    fonteFinanciamento,
    projeto,
    reavaliacao,
    parametros,
    documento,
    relatoriosTce,
    ajuste,
}
